import React, { Suspense } from 'react';
import {
  BrowserRouter,
} from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from "./store"
import { Loader } from 'components';
import { ToastContainer } from 'react-toastify';
import { LogtoProvider, LogtoConfig, UserScope } from '@logto/react';

const config: LogtoConfig = {
  endpoint: 'https://logto.natrixsoftware.in/',
  appId: 'an48yd1q9bfq3qmkdwxde',
  scopes: [
    UserScope.Email
  ],
};

const HRMSRoutes = React.lazy(() => import('./routes'));

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <LogtoProvider config={config}>
        <Provider store={store}>
          <BrowserRouter>
            <ToastContainer />
            <HRMSRoutes />
          </BrowserRouter>
        </Provider>
      </LogtoProvider>
    </Suspense>
  );
}

export default App;
